/* ─────────────────────────────────────────────────────────────
   NCP Gründerstory Landingpage — vanilla interactivity
   Pack selector + Sparabo toggle + live price sync.
   ───────────────────────────────────────────────────────────── */
(function(){
  function init(root){
    var fmt = function(n){ return n.toFixed(2).replace('.', ',') + ' €'; };

    var tiles  = root.querySelectorAll('[data-pack]');
    if (!tiles.length) return;
    var ctas   = root.querySelectorAll('[data-cta]');
    var prices = root.querySelectorAll('[data-final-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickySaved = root.querySelector('[data-sticky-saved]');
    var compareText = root.querySelector('[data-compare-text]');
    var savingsText = root.querySelector('[data-savings-text]');
    var initialTile = root.querySelector('[data-pack].is-on') || tiles[0];
    var current = {
      price:   parseFloat(initialTile.dataset.price),
      compare: parseFloat(initialTile.dataset.compare),
      disc:    parseInt(initialTile.dataset.disc, 10),
      url:     initialTile.dataset.url,
    };

    function recompute(){
      var price = current.price;
      var disc  = current.disc;
      prices.forEach(function(el){ el.textContent = fmt(price); });
      if (stickyPrice) stickyPrice.textContent = fmt(price);
      if (stickySaved) stickySaved.textContent = 'spare −' + disc + ' %';
      if (compareText) compareText.textContent = fmt(current.compare).replace(' €','');
      if (savingsText) savingsText.textContent = '−' + disc + ' %';
      ctas.forEach(function(a){ a.setAttribute('href', current.url); });
    }

    tiles.forEach(function(tile){
      tile.addEventListener('click', function(){
        tiles.forEach(function(t){ t.classList.remove('is-on'); t.setAttribute('aria-checked','false'); });
        tile.classList.add('is-on');
        tile.setAttribute('aria-checked','true');
        current.price   = parseFloat(tile.dataset.price);
        current.compare = parseFloat(tile.dataset.compare);
        current.disc    = parseInt(tile.dataset.disc, 10);
        current.url     = tile.dataset.url;
        recompute();
      });
    });

    recompute();
    // (founder video plays muted autoplay loop, no JS hook needed)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      document.querySelectorAll('.section-ncp-landing').forEach(init);
    });
  } else {
    document.querySelectorAll('.section-ncp-landing').forEach(init);
  }

  // Shopify theme-editor live-reload hook
  document.addEventListener('shopify:section:load', function(e){
    var s = e.target.querySelector('.section-ncp-landing') || (e.target.classList && e.target.classList.contains('section-ncp-landing') ? e.target : null);
    if (s) init(s);
  });
})();
